import React, {useState} from "react";
import axios from 'axios';
import Heading from "./heading";
import Social from "./social";

export default function Login(){
    const [url, changeUrl] = useState("")
    const [message, changeMessage] = useState(false)
    const [invalid, changeInvalid] = useState(false)
    const [userColor, changeColor] = useState("")
    const [wrongColor, changeWrongColor] = useState(false)
    const [dataToSend, changeDatatoSend] = useState({})
    const [logging, changeLogging] = useState(true)
    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');
    const [showColor, setColor] = useState(false)
    const ind = Math.floor(Math.random() * 3);
    const [formData, setFormData] = useState({
      username: '',
      password: '',
    });

    function register(){
      const dataToSend = {key1: parameterValue};
      const queryString = new URLSearchParams(dataToSend).toString();
      const url = `/register?${queryString}`;
      window.location.href = url
  }

    const handleChange = (event) => {
      const { name, value } = event.target;
      setFormData({ ...formData, [name]: value });
    };

    function getRandomColor() {
      // Generate random values for red, green, and blue components
      let red = Math.floor(Math.random() * 256) - 50;
      let green = Math.floor(Math.random() * 256) - 50;
      let blue = Math.floor(Math.random() * 256) - 50;
      
      if(red <= 0){
        red = 10
      }
      if(green <= 0){
        green = 10
      }
      if(blue <= 10){
        blue = 10
      }
      
      // Return the RGB color string
      return `(${red},${green},${blue})`;
    }
    
    const handleBackend = (color) => {
      const sendBackend = async () => {
        try{
          axios.post('https://nvedemo24-backend-server.vercel.app/color',{color: color,userid: dataToSend.key1})
          .then((res) => {
            if(res.data.value === true){
              window.location.href = url
            }
            else{
              changeWrongColor(true)
              changeMessage(false)
              setColor(false)
            }
          })
        }
        catch(error){
          console.log(error)
        }
      }
      sendBackend()
    }

    const handleSubmit = (event) => {

      changeMessage(false)
        if(formData.username !== '' && formData.password !== ''){
            event.preventDefault();
            // Perform actions with form data, such as submitting to a server
            // console.log(formData);
            
            const sendData = async () => {
                try {
                await axios.post('https://nvedemo24-backend-server.vercel.app/login',formData)
                .then((res) => {

                    changeDatatoSend({key1: res.data.username})
                    changeColor(res.data.color)
                    const queryString = new URLSearchParams({key1: res.data.username}).toString();
                    changeUrl(`/demo?${queryString}`);
                    setColor(true)
                    changeLogging(false)
                });
                } catch (err){
                    console.log(err)
                    if(err.response.status === 401){
                      changeInvalid(true)
                    }
                }
            }
            sendData();

        }
        else{
            changeMessage(true)
            setColor(false)
        }
    };

    function login(){
      const parameterValue = searchParams.get('key1');
      const url = `/login?${new URLSearchParams({key1: parameterValue}).toString()}`;
      window.location.href = url
    }

    return(
      <>
        <Heading/>
        {logging &&
        <>
           <h1 className="demo-heading" style={{fontSize: '32pt'}}>LOGIN</h1>
          <div className="login-container">
              <div className="left-login">
                  <input className="login-input" placeholder="USERNAME" value={formData.username} id="username" name="username" onChange={handleChange}/>
                  <input className="login-input" placeholder="PASSWORD" value={formData.password} id="password" name="password" onChange={handleChange}/>
                  <div className="login-button-container">
                  {message && <h1 className="user-taken">PLEASE FILL OUT ALL CREDENTIALS</h1>}
                  {invalid && <h1 className="user-taken">INCORRECT USERNAME OR PASSWORD</h1>} 
                  <button className="login-button" type="button" onClick={handleSubmit}>LOGIN</button>
                    <button className="left-text" onClick={register}>Don't have an account? Click here to register</button>
                  </div>
              </div>
          </div>
        </>
        }
        {showColor &&
        <>
          <p className="right-text" style={{textAlign: "center"}}>CHOOSE YOUR LOGIN COLOR</p>
          <div className="choose-colors">
              {/* <div className="selected-color" style={{ backgroundColor: `rgb${getRandomColor()}`, border: "4px solid rgb(100, 100, 100)" }}></div>
              <div className="selected-color" style={{ backgroundColor: `rgb${getRandomColor()}`, border: "4px solid rgb(100, 100, 100)" }}></div>
              <div className="selected-color" style={{ backgroundColor: `rgb${getRandomColor()}`, border: "4px solid rgb(100, 100, 100)" }}></div> */}
              {[...Array(3)].map((_, index) => {
                  let random = null
                  if(index === ind){
                    random = userColor
                  }
                  else{
                    random = `rgb${getRandomColor()}`
                  }
                  return (
                      <button onClick={() => handleBackend(random)}><div key={index} className="selected-color" style={{ backgroundColor: random, border: "4px solid rgb(100, 100, 100)" }}></div></button>
                  );
              })}
          </div>
        </>
        }
        {wrongColor &&
        <>
          <h1 className="demo-heading">YOU SELECTED THE WRONG COLOR, PLEASE TRY AGAIN</h1>
          <div className="error-container">
            <button to="/login" className="demo-nav-child-2" onClick={login} style={{margin: "25px"}}>LOGIN</button>
          </div>
        </>
        }
        <Social/>
      </>
    )
}
